import SingleSelect from './singleSelect.vue';

export default {
    name: 'FavoritesPanel',
    template: '#realty-search-favorites-panel',
    components: { SingleSelect },
    data() {
        return {
            resultsPerPage: String(CONFIG.misc.params.results_per_page),

            metaFields: {},
        };
    },
    mounted() {
        this.metaFields = { ...CONFIG.misc.metaFields };
    },
    methods: {
        showResults() {
            this.$nextTick(() => {
                const url = new URL(location.href),
                    param = 'results_per_page',
                    value = this.resultsPerPage;

                if (value) {
                    url.searchParams.set(param, value);
                } else {
                    url.searchParams.delete(param);
                }

                location.href = decodeURI(url.href);
            });
        },
    },
};
